import React, { useState } from "react";
import "../ListHeader/ListHeader.css";
import CustomerOverlay from "../CustomerOverlay";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";

const ListHeader = ({
    search,
    setSearch,
    columnSearch,
    setColumnSearch,
    onRefresh,
}) => {
    const [showOverlay, setShowOverlay] = useState(false);
    const [lastLoginStart, setLastLoginStart] = useState(null);
    const [lastLoginEnd, setLastLoginEnd] = useState(null);
    const [lastTxnStart, setLastTxnStart] = useState(null);
    const [lastTxnEnd, setLastTxnEnd] = useState(null);
    const handleRefresh = () => {
        setSearch("");
        setLastLoginStart(null);
        setLastLoginEnd(null);
        setLastTxnStart(null);
        setLastTxnEnd(null);
        setColumnSearch({status:"active",
             customerName: "",
        mobile: "",
        coins: "",
        createdBy: "",
        companyName: "",
        lastLoginStartDate: null,
        lastLoginEndDate: null,
        lastTransactionStartDate: null,
        lastTransactionEndDate: null,
        lastLogin: "",
        lastTransaction: "",
        reference: "",
        address: "",
        mapLocation: "",
        });
        if (onRefresh) {
            onRefresh();
        }
    };
    return (
        <>
            <div className="list-header">
                <div className="list-header-left">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={search}
                        className="list-search-input"
                        onChange={(e) => setSearch(e.target.value)}
                    />

                    <div className="customer-list-date-wrapper">
                        <DatePicker
                            selected={lastLoginStart}
                            onChange={(date) => {
                                setLastLoginStart(date);
                                setColumnSearch({
                                    ...columnSearch,
                                    lastLoginStartDate: date,
                                });
                            }}
                            placeholderText="Last Login Start"
                            dateFormat="dd/MM/yyyy"
                            showPopperArrow={false}
                            className="customer-list-date-picker"
                            portalId="root"
                        />
                        <FaCalendarAlt className="customer-list-calendar-icon" />
                    </div>

                    <div className="customer-list-date-wrapper">
                        <DatePicker
                            selected={lastLoginEnd}
                            onChange={(date) => {
                                setLastLoginEnd(date);
                                setColumnSearch({
                                    ...columnSearch,
                                    lastLoginEndDate: date,
                                });
                            }}
                            placeholderText="Last Login End"
                            dateFormat="dd/MM/yyyy"
                            showPopperArrow={false}
                            className="customer-list-date-picker"
                            portalId="root"
                        />
                        <FaCalendarAlt className="customer-list-calendar-icon" />
                    </div>

                    <div className="customer-list-date-wrapper">
                        <DatePicker
                            selected={lastTxnStart}
                            onChange={(date) => {
                                setLastTxnStart(date);
                                setColumnSearch({
                                    ...columnSearch,
                                    lastTransactionStartDate: date,
                                });
                            }}
                            placeholderText="Transaction Start"
                            dateFormat="dd/MM/yyyy"
                            showPopperArrow={false}
                            className="customer-list-date-picker"
                            portalId="root"
                        />
                        <FaCalendarAlt className="customer-list-calendar-icon" />
                    </div>

                    <div className="customer-list-date-wrapper">
                        <DatePicker
                            selected={lastTxnEnd}
                            onChange={(date) => {
                                setLastTxnEnd(date);
                                setColumnSearch({
                                    ...columnSearch,
                                    lastTransactionEndDate: date,
                                });
                            }}
                            placeholderText="Transaction End"
                            dateFormat="dd/MM/yyyy"
                            showPopperArrow={false}
                            className="customer-list-date-picker"
                            portalId="root"
                        />
                        <FaCalendarAlt className="customer-list-calendar-icon" />
                    </div>
                </div>

                <div className="list-header-right">
                    <span
                        className="refresh-icon"
                        title="Refresh"
                        onClick={handleRefresh}
                    >
                        ⟳
                    </span>

                    <span
                        className="add-plus"
                        onClick={() => setShowOverlay(true)}
                    >
                        +
                    </span>
                </div>
            </div>

            {showOverlay && (
                <CustomerOverlay
                    onClose={() => setShowOverlay(false)}
                    onSave={() => {
                        setShowOverlay(false);
                        if (onRefresh) onRefresh();
                    }}
                />
            )}
        </>
    );
};

export default ListHeader;
